import { render, staticRenderFns } from "./ReplyTech.vue?vue&type=template&id=76938366&scoped=true&"
import script from "./ReplyTech.vue?vue&type=script&lang=js&"
export * from "./ReplyTech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76938366",
  null
  
)

export default component.exports